var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fullscreen-bg"},[_c('button',{staticClass:"back-button",on:{"click":_vm.goBack}},[_vm._v(" 返回 ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }